'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".OrderLookupField-module_container__45Git{position:relative}.OrderLookupField-module_orderLookup__wlcqh{padding:.5rem .75rem;position:absolute;right:0;top:50%;transform:translateY(-50%)}.OrderLookupField-module_containerStatic__brdpL{display:flex;justify-content:space-between;padding:.625rem 0}";
var styles = {"container":"OrderLookupField-module_container__45Git","orderLookup":"OrderLookupField-module_orderLookup__wlcqh","containerStatic":"OrderLookupField-module_containerStatic__brdpL"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
